export const API_BASE_URL = 'http://apikarallantas.jorgeplazadev.com/';
export const Instagram = 'https://www.instagram.com/karallantas?igsh=MWh2eG5oNWRxNGd2Zg==';